/**
 * IA NAS AGENCIAS — VIDEO 7/9 (Pilares)
 * SlideType: checklist | 10s | 720x900
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolate, Easing, spring} from "remotion";
import {TOKEN_PRESETS, FONT_PRESETS} from "../../templates/carrossel/EditorialTechNews";

const CLAMP = {extrapolateLeft: "clamp" as const, extrapolateRight: "clamp" as const};
const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const slideUp = (frame: number, start: number, end: number, dist = 20) =>
  interpolate(frame, [start, end], [dist, 0], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

export const IAA07Pilares: React.FC = () => {
  const frame = useCurrentFrame();
  const accent = "#00DF82";
  const items = ["Processo documentado", "Output revisado por humano", "IA como amplificador, não substituto"];

  return (
    <AbsoluteFill style={{backgroundColor: "#1A1D26"}}>
      <div style={{position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)", backgroundSize: "40px 40px"}} />
      <div style={{position: "absolute", top: 30, left: 50, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_PRESETS.mono, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: "#888888"}}>IA NAS AGENCIAS</div>
      <div style={{position: "absolute", top: 110, left: 50, opacity: fadeIn(frame, 5, 20), transform: `translateY(${slideUp(frame, 5, 20)})`, fontFamily: FONT_PRESETS.serif, fontSize: 48, fontWeight: 700, lineHeight: 1.15, color: "#FFFFFF", maxWidth: 620}}>IA funciona com 3 pilares:</div>
      <div style={{position: "absolute", top: 200, left: 50, right: 50, display: "flex", flexDirection: "column", gap: 14}}>
        {items.map((item, i) => {
          const fd = 20 + i * 10;
          const itemSpring = spring({frame: frame - fd, fps: 30, config: {damping: 14, stiffness: 180, mass: 1}});
          const bulletSpring = spring({frame: frame - fd, fps: 30, config: {damping: 16, stiffness: 200, mass: 0.8}});
          return (
            <div key={i} style={{display: "flex", alignItems: "center", gap: 12, opacity: interpolate(itemSpring, [0, 0.5, 1], [0, 0, 1], {extrapolateRight: CLAMP}), transform: `translateX(${interpolate(itemSpring, [0, 1], [15, 0], {extrapolateRight: CLAMP, easing: Easing.out(Easing.ease)})}px)`}}>
              <div style={{width: 22, height: 22, borderRadius: "50%", background: accent, display: "flex", alignItems: "center", justifyContent: "center", transform: `scale(${interpolate(bulletSpring, [0, 0.6, 1], [0.3, 1.1, 1], {extrapolateRight: CLAMP})})`, flexShrink: 0}}>
                <span style={{fontSize: 11, color: "#000", fontWeight: 700}}>✓</span>
              </div>
              <div style={{fontFamily: FONT_PRESETS.serif, fontSize: 22, fontWeight: 600, lineHeight: 1.3, color: "#FFFFFF"}}>{item}</div>
            </div>
          );
        })}
      </div>
      <div style={{position: "absolute", bottom: 40, left: 50, right: 50, display: "flex", justifyContent: "space-between", opacity: fadeIn(frame, 40, 50)}}>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 15, color: "#888888"}}>@guilhermeribeiro.ai</span>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 13, color: "#888888"}}>7/9</span>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
